import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from '@mui/icons-material/Send';

import localStorageHelper from 'utils/localStorageHelper';

import QualificationTable from './QualificationTable';

import { CategorieCodes } from 'constants.js';
import { QualificationCodes } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { ReclamationQualificationDetailType } from 'constants.js';
import { TypePiece } from 'constants.js';


import Datetime from 'components/Shared/Datetime';
import Utilisateur from 'components/Shared/Utilisateur';
import PdfLoadingButton from 'components/Shared/PdfLoadingButton';
import CsvLoadingButton from 'components/Shared/CsvLoadingButton';
import DetailReparation from 'components/Shared/DetailReparation';

import Fichier from 'components/Shared/Fichier';

// eslint-disable-next-line
import ReclamationPageHeader from 'components/Screens/ReclamationPage/ReclamationPageHeader/ReclamationPageHeader.js';
import { GarantieType, GarantieTypeNoms } from '../../../../constants';
import ReclamationLitige from '../Litige/ReclamationLitige';

import { NotificationImportance } from 'store/common/commonActions';

const styles = theme => ({
    paper: {
        marginBottom: theme.spacing(2),

        display: 'flex',
        flexDirection: 'column',

        padding: theme.spacing(2)
    },

    container: {
        display: 'flex',
        width: '100%',
        alignItems: 'baseline'
    },

    containerLeft: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'baseline'
    },

    containerRight: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%'
    },

    marginRight: {
        //marginRight: theme.spacing(1),
        margin: theme.spacing(1, 1, 0, 0),
        fontVariantCaps: 'small-caps'
    },

    qualificationDetailLibelle: {
        marginRight: theme.spacing(1),
        whiteSpace: 'nowrap'
    },
    

    marginRightLarge: {
        marginRight: theme.spacing(2),
        whiteSpace: 'pre-line'
    },

    divider: {
        margin: theme.spacing(1, 0, 1, 0)
    },

    table: {
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },

    filescontainer: {
        display: 'flex',
        alignItems: 'center',

        flexFlow: 'row wrap'
    },
    detailValue: {
        whiteSpace: 'pre-line',
        width: '100%'
    },

    link: theme.style.link,

    leftIcon: {
        marginRight: theme.spacing(1)
    },

    iconSmall: {
        fontSize: 20
    },

    documentPaper: {

        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),

        display: 'flex',
        flexDirection: 'row',

        '&:empty': {
          display: 'none'
        },
    }

});

class Qualification extends React.Component {

    state = {
        erreurPreuveDAChat: false,
        erreurConditionsSAV: false,

        loadingPriseEnCharge: false,
        loadingDocumentFournisseur: false,
        loadingPreuveDAChat: false,
        loadingConditionsSAV: false,
        loadingDocRepriseMarchandise: false,
        loadingCSVFournisseur: false,

        loadingDocRepriseMarchandiseIncidentLivraison: false,

        loadingReplayMailRepriseMarchandise: false,
    };

    isDevelopment = process.env.NODE_ENV === 'development';

    handleDownloadPriseEnCharge = () => {
        let { reclamationId, addNotification } = this.props;

        this.setState({ loadingPriseEnCharge: true });

        axios.post(`api/reclamations/${reclamationId}/exporter-formulaire-prise-en-charge`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data])); 

                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch(function (error) {
                console.log(error);
                addNotification(`Erreur à la génération du formulaire de prise en charge sur le dossier ${reclamationId}, veuillez contacter le support.`, NotificationImportance.error, true, null );
            })
            .then(() => {
                // always executed
                this.setState({ loadingPriseEnCharge: false });
            });
    };


    handleDownloadDocumentFournisseur = () => {
        let { reclamationId } = this.props;

        this.setState({ loadingDocumentFournisseur: true });

        axios.post(`api/reclamations/${reclamationId}/exporter-document-fournisseur`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch(function (error) {
                console.log(error);
                addNotification(`Erreur à la génération du document fournisseur sur le dossier ${reclamationId}, veuillez contacter le support.`, NotificationImportance.error, true, null );
            })
            .then(() => {
                // always executed
                this.setState({ loadingDocumentFournisseur: false });
            });

    };


    handleDownloadDocumentCSVFournisseur = () => {
        let { reclamationId } = this.props;

        this.setState({ loadingCSVFournisseur: true });

        axios.post(`api/reclamations/${reclamationId}/exporter-csv-fournisseur`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch(function (error) {
                console.log(error);
                addNotification(`Erreur à la génération du csv fournisseur sur le dossier ${reclamationId}, veuillez contacter le support.`, NotificationImportance.error, true, null );
            })
            .then(() => {
                // always executed
                this.setState({ loadingCSVFournisseur: false });
            });

    };



    handleDownloadConditionsSAVFournisseur = () => {

        this.setState({ erreurConditionsSAV: false, loadingConditionsSAV: true });

        let { reclamationId } = this.props;

        axios.post(`api/reclamations/${reclamationId}/exporter-conditionsSAV`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurConditionsSAV: true });
            })
            .then(() => {
                // always executed
                this.setState({ loadingConditionsSAV: false });

            });

    };


    handleDownloadPreuveAchat = (numeroPiece) => {

        this.setState({ erreurPreuveDAChat: false, loadingPreuveDAChat: true });

        axios.post(`api/pieces-gestion/${numeroPiece}/export`, {}, { responseType: 'blob' })
            .then(function (response) {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', numeroPiece + '.pdf');
                document.body.appendChild(link);
                link.click();
            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurPreuveDAChat: true });

            })
            .then(() =>{
                // always executed
                this.setState({ loadingPreuveDAChat: false });
            });
    }



    handleDownloadDocRepriseMarchandise = () => {

        this.setState({ erreurDocRepriseMarchandise: false, loadingDocRepriseMarchandise: true });

        let { reclamationId } = this.props;

        axios.post(`api/reclamations/${reclamationId}/exporter-documentRepriseMarchandise`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurDocRepriseMarchandise: true });
            })
            .then(() => {
                // always executed
                this.setState({ loadingDocRepriseMarchandise: false });

            });

    };


    handleReplayMailRepriseMarchandise = () => {
        const { reclamationId, addNotification } = this.props;

        this.setState({ loadingReplayMailRepriseMarchandise: true });

        axios.post(`api/reclamations/${reclamationId}/replay-mail-reprise-marchandise`)
            .then(() => {
                addNotification(`Mail de reprise marchandise renvoyé à votre adresse pour le dossier ${reclamationId}.`, NotificationImportance.success, true, null);
            })
            .catch((error) => {
                console.log(error);
                addNotification(`Erreur au renvoi du mail de reprise marchandise pour le dossier ${reclamationId}.`, NotificationImportance.error, true, null);
            })
            .then(() => {
                this.setState({ loadingReplayMailRepriseMarchandise: false });
            });
    };


    handleDownloadDocRepriseMarchandiseIncidentLivraison = () => {

        this.setState({ erreurDocRepriseMarchandiseIncidentLivraison: false, loadingDocRepriseMarchandiseIncidentLivraison: true });

        let { reclamationId } = this.props;

        axios.post(`api/reclamations/${reclamationId}/exporter-documentRepriseMarchandiseIncidentLivraison`, {}, { responseType: 'blob' })
            .then(function (response) {

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const contentDisposition = response.headers['content-disposition'];

                const regex = new RegExp("filename[^;=\\n]*=['\"]?(?:UTF-\\d['\"]*)?([^;\\r\\n\"']*)['\"]?;?"); // https://stackoverflow.com/questions/23054475/javascript-regex-for-extracting-filename-from-content-disposition-header

                const match = regex.exec(contentDisposition);

                const filename = match[1]; // On prend le groupe 1

                link.setAttribute('download', decodeURIComponent(filename));

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            })
            .catch((error) => {
                console.log(error);
                this.setState({ erreurDocRepriseMarchandiseIncidentLivraison: true });
            })
            .then(() => {
                // always executed
                this.setState({ loadingDocRepriseMarchandiseIncidentLivraison: false });

            });

    };



    render() {
        let { classes, reclamationId, qualifications } = this.props;
        let { erreurPreuveDAChat, erreurConditionsSAV, erreurDocRepriseMarchandise, erreurDocRepriseMarchandiseIncidentLivraison,
            loadingPriseEnCharge,
            loadingDocumentFournisseur,
            loadingPreuveDAChat,
            loadingConditionsSAV,
            loadingDocRepriseMarchandise,
            loadingDocRepriseMarchandiseIncidentLivraison,
            loadingCSVFournisseur,
            loadingReplayMailRepriseMarchandise
        } = this.state;

        if (!qualifications) {
            return null;
        }

        let garantieProduit = "";
        let afficheTelechargementDocSAV = false;
        let savByFoussier = false;
        if (qualifications.qualification.code === QualificationCodes.Sav && qualifications.details !== undefined) {

            const detailAcceptationOK = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.AcceptationSAV && detail.value === true);

            let detailGarantieProduit = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.GarantieProduit);

            if (detailGarantieProduit) {
                garantieProduit = detailGarantieProduit.value.libelle;
            }

            if (detailAcceptationOK) {
                afficheTelechargementDocSAV = true;


                savByFoussier = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.SavByFoussierConcerne);

                // Dans le cas du SAV par foussier, la prise en charge peut modifier l'affichage de la garantie - RECLA-854
                if (savByFoussier) {
                    let priseEnCharge = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.SavByFoussierPriseEnCharge);

                    if (priseEnCharge) {

                        switch (priseEnCharge.value.choix) {
                            case "0":
                                garantieProduit = GarantieTypeNoms[GarantieType.SousGarantieApresUtilisation];
                                break;
                            case "1":
                                garantieProduit = GarantieTypeNoms[GarantieType.HorsGarantie];
                                break;
                            case "2":
                                garantieProduit = GarantieTypeNoms[GarantieType.HorsGarantie];
                                break;
                            default:
                                break;
                        }
                    }
                }
            }




        }


        let afficheTelechargementDocRepriseMarchandise = false;

        if (qualifications.categorie.code === CategorieCodes.DemandeRetourMarchandiseLivreeConforme) {

            
            const detailRetourMontantEstimeAvoir = qualifications.details.find(detail =>
                detail.code === ReclamationQualificationDetailCodes.RetourMontantEstimeAvoir
                || detail.code === ReclamationQualificationDetailCodes.RetourMontantEstimeAvoirObfusque);

            if (detailRetourMontantEstimeAvoir) {
                afficheTelechargementDocRepriseMarchandise = true;
            }


        }

        let afficheTelechargementDocRepriseMarchandiseIncidentLivraison = false;

        if (qualifications.categorie.code === CategorieCodes.ProblemeReception) {

            //const detailProduitCommande = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.ProduitCommande);
            const detailClientInforme = qualifications.details.find(detail => detail.code === ReclamationQualificationDetailCodes.ClientInforme);

            if (detailClientInforme) {
                afficheTelechargementDocRepriseMarchandiseIncidentLivraison = true;
            }

        }

        return (
            <React.Fragment>
                <Paper className={classes.paper}>
                    <div className={classes.container}>
                        <Typography className={classes.marginRight}>Type : </Typography>
                        <Typography className={classes.marginRightLarge} variant="body2">{qualifications.type ? qualifications.type.libelle : ''}</Typography>
                        <Typography className={classes.marginRight}>Catégorie : </Typography>
                        <Typography className={classes.marginRightLarge} variant="body2">{qualifications.categorie ? qualifications.categorie.libelle : ''}</Typography>
                        <Typography className={classes.marginRight}>Qualification : </Typography>
                        <Typography className={classes.marginRightLarge} variant="body2">{qualifications.qualification ? qualifications.qualification.libelle : ''}</Typography>

                        {garantieProduit && (
                            <>
                                <Typography className={classes.marginRight}>Type de garantie : </Typography>
                                <Typography className={classes.marginRightLarge} variant="body2">{garantieProduit}</Typography>
                            </>
                        )}


                        {qualifications.depot && (
                            <>
                                <Typography className={classes.marginRight}>Magasin : </Typography>
                                <Typography className={classes.marginRightLarge} variant="body2">{`${qualifications.depot.codeDepot} - ${qualifications.depot.nom}`}</Typography>
                            </>
                        )}

                    </div>
                    {qualifications.commentaire && (
                        <React.Fragment>
                            <Divider className={classes.divider} />
                            <Typography className={classes.marginRight}>Commentaire</Typography>
                            <Typography className={classes.marginRightLarge} variant="body2">{qualifications.commentaire}</Typography>
                        </React.Fragment>
                    )}

                    {qualifications.filesIds && qualifications.filesIds.length > 0 && (
                        <React.Fragment>
                            <Divider className={classes.divider} />
                            <div className={classes.container}>
                                <Typography variant="body1" gutterBottom className={classes.marginRight}>Pièces jointes</Typography>


                                <div className={classes.filescontainer}>
                                    {qualifications.filesIds.map(x => <Fichier key={x} fichierId={x} />)}
                                </div>

                            </div>
                        </React.Fragment>
                    )}


                </Paper>



                <Paper className={classes.documentPaper}>

                    {afficheTelechargementDocSAV && (
                        <>

                            {this.props.qualifications.fournisseur && this.props.qualifications.fournisseur.conditionSAV && (

                                <PdfLoadingButton
                                    style={{ margin: '8px 8px 0px 0px' }}
                                    pending={loadingConditionsSAV}
                                    onClick={this.handleDownloadConditionsSAVFournisseur}
                                    label={'Conditions SAV fournisseur'}
                                    disabled={!!qualifications.restrictionsTelechargement.conditionsSAVFournisseur}
                                    tooltip={qualifications.restrictionsTelechargement.conditionsSAVFournisseur}
                                />

                            )}


                            <PdfLoadingButton
                                style={{ margin: '8px 8px 0px 0px' }}
                                pending={loadingPriseEnCharge}
                                onClick={this.handleDownloadPriseEnCharge}
                                label={'Formulaire de prise en charge'}
                                disabled={!!qualifications.restrictionsTelechargement.formulaireDePriseEnCharge}
                                tooltip={qualifications.restrictionsTelechargement.formulaireDePriseEnCharge}
                            />


                            {!savByFoussier && (

                                <PdfLoadingButton
                                    style={{ margin: '8px 8px 0px 0px' }}
                                    pending={loadingDocumentFournisseur}
                                    onClick={this.handleDownloadDocumentFournisseur}
                                    label={'Document fournisseur'}
                                    disabled={!!qualifications.restrictionsTelechargement.documentFournisseur}
                                    tooltip={qualifications.restrictionsTelechargement.documentFournisseur}
                                />

                            )}


                            {savByFoussier && (
                                <PdfLoadingButton
                                    style={{ margin: '8px 8px 0px 0px' }}
                                    pending={loadingDocumentFournisseur}
                                    onClick={this.handleDownloadDocumentFournisseur}
                                    label={'Document fournisseur - SAV by Foussier'}
                                    disabled={!!qualifications.restrictionsTelechargement.documentFournisseurSAVByFoussier}
                                    tooltip={qualifications.restrictionsTelechargement.documentFournisseurSAVByFoussier}
                                />
                            )}


                            {savByFoussier && this.props.qualifications.fournisseur && this.props.qualifications.fournisseur.emailSuiviSAVByFoussier && (
                                <CsvLoadingButton
                                    style={{ margin: '8px 8px 0px 0px' }}
                                    pending={loadingCSVFournisseur}
                                    onClick={this.handleDownloadDocumentCSVFournisseur}
                                    label={'CSV - SAV by Foussier'}
                                    disabled={!!qualifications.restrictionsTelechargement.cSVSAVByFoussier}
                                    tooltip={qualifications.restrictionsTelechargement.cSVSAVByFoussier}
                                />
                            )}



                            {this.props.numeroPiece && (

                                <PdfLoadingButton
                                    style={{ margin: '8px 8px 0px 0px' }}
                                    pending={loadingPreuveDAChat}
                                    onClick={e => this.handleDownloadPreuveAchat(this.props.numeroPiece)}
                                    label={"Preuve d'achat"}
                                    disabled={!!qualifications.restrictionsTelechargement.preuveDAchat}
                                    tooltip={qualifications.restrictionsTelechargement.preuveDAchat}
                                />
                            )}




                            {this.props.qualifications.fournisseur && this.props.qualifications.fournisseur.conditionSAV && this.props.qualifications.fournisseur.conditionSAV.ficheRetour && (
                                <>

                                    <Fichier
                                        className={classes.marginRight}
                                        variant="contained"
                                        color="primary"
                                        size="medium"
                                        label="Fiche retour fournisseur"
                                        fichierId={this.props.qualifications.fournisseur.conditionSAV.ficheRetour.id}
                                    />

                                </>
                            )}

                        </>
                    )}

                    {afficheTelechargementDocRepriseMarchandise && (

                        <PdfLoadingButton
                            style={{ margin: '8px 8px 0px 0px' }}
                            pending={loadingDocRepriseMarchandise}
                            onClick={this.handleDownloadDocRepriseMarchandise}
                            label={"Document reprise marchandise"}
                            disabled={!!qualifications.restrictionsTelechargement.documentRepriseMarchandise}
                            tooltip={qualifications.restrictionsTelechargement.documentRepriseMarchandise}
                        />

                    )}

                    {afficheTelechargementDocRepriseMarchandise && localStorageHelper.isAdmin() && (
                        <Tooltip title="Rejouer l'envoi du mail de reprise marchandise à votre adresse (admin)">
                            <span style={{ margin: '8px 8px 0px 0px' }}>
                                <IconButton
                                    onClick={this.handleReplayMailRepriseMarchandise}
                                    disabled={loadingReplayMailRepriseMarchandise}
                                    sx={{ color: '#ff9800' }}
                                    size="small"
                                >
                                    {loadingReplayMailRepriseMarchandise
                                        ? <CircularProgress size={20} sx={{ color: '#ff9800' }} />
                                        : <SendIcon />}
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}

                    {afficheTelechargementDocRepriseMarchandiseIncidentLivraison && (

                        <PdfLoadingButton
                            style={{ margin: '8px 8px 0px 0px' }}
                            pending={loadingDocRepriseMarchandiseIncidentLivraison}
                            onClick={this.handleDownloadDocRepriseMarchandiseIncidentLivraison}
                            label={"Document reprise marchandise Incident Livraison"}
                            disabled={!!qualifications.restrictionsTelechargement.DocumentRepriseMarchandiseIncidentLivraison}
                            tooltip={qualifications.restrictionsTelechargement.DocumentRepriseMarchandiseIncidentLivraison}
                        />
                    )}


                    <DetailReparation
                        reclamationId={reclamationId}
                        style={{ margin: '8px 8px 0px 0px' }}
                    />

                </Paper>

                <>
                    {erreurPreuveDAChat && (
                        <p>La preuve d'achat est indisponible, vous pouvez la rééditer depuis FMCP.</p>
                    )}

                    {erreurConditionsSAV && (
                        <p>Impossible de récupèrer les conditions SAV de ce fournisseur.</p>
                    )}


                    {erreurDocRepriseMarchandise && (
                        <p>Impossible de récupèrer le document de reprise marchandise.</p>
                    )}

                    {erreurDocRepriseMarchandiseIncidentLivraison && (
                        <p>Impossible de récupèrer le document de reprise marchandise sur incident de livraison.</p>
                    )}
                </>



                {qualifications.piece && (
                    <Paper className={classes.paper}>
                        <div className={classes.container}>
                            {qualifications.typePiece === TypePiece.Commande ? (
                                <>
                                    <Typography className={classes.marginRight}>Commande : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">
                                        {qualifications.piece.commandeOrigine ? `C${qualifications.piece.commandeOrigine}` : ''}
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Typography className={classes.marginRight}>Pièce : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">
                                        {qualifications.piece.numeroPiece}
                                        {qualifications.piece.numeroPreparation && qualifications.piece.numeroPreparation !== qualifications.piece.numeroPiece
                                            ? ` - ${qualifications.piece.numeroPreparation}`
                                            : ''}
                                    </Typography>

                                    {qualifications.piece.commandeOrigine && (
                                        <>
                                            <Typography className={classes.marginRight}>Commande d'origine : </Typography>
                                            <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.commandeOrigine}</Typography>
                                        </>
                                    )}
                                </>
                            )}


                            {qualifications.typePiece === TypePiece.Commande ? (
                                <>
                                    <Typography className={classes.marginRight}>Référence : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.referenceCommande}</Typography>
                                    <Typography className={classes.marginRight}>Date : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">
                                        {qualifications.piece.dateCommande ? new Date(qualifications.piece.dateCommande).toLocaleDateString('fr-FR') : ''}
                                    </Typography>
                                    <Typography className={classes.marginRight}>Mode livraison : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.modeLivraison}</Typography>
                                    {qualifications.transporteur && (
                                        <>
                                            <Typography className={classes.marginRight}>Transporteur : </Typography>
                                            <Typography className={classes.marginRightLarge} variant="body2">{qualifications.transporteur}</Typography>
                                        </>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Typography className={classes.marginRight}>Expédition demandée : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.dateExpedition}</Typography>
                                    <Typography className={classes.marginRight}>Mode livraison : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.modeLivraison}</Typography>
                                    <Typography className={classes.marginRight}>Référence commande : </Typography>
                                    <Typography className={classes.marginRightLarge} variant="body2">{qualifications.piece.referenceCommande}</Typography>
                                </>
                            )}
                        </div>
                        {(qualifications.lignes !== undefined && qualifications.lignes.length > 0) && (
                            <React.Fragment>
                                <Divider className={classes.divider} />
                                <div className={classes.table}>
                                    <QualificationTable lignes={qualifications.lignes} typePiece={qualifications.typePiece} />
                                </div>
                            </React.Fragment>
                        )}
                    </Paper>
                )}

                {qualifications.litige && (
                    <ReclamationLitige litige={qualifications.litige} />
                )}


                {qualifications.tauxReclamationSociete && (
                    <Paper className={classes.paper}>

                        <p>Taux de dossier après-vente société : {qualifications.tauxReclamationSociete}% - Taux de dossier après-vente client : <span style={{ backgroundColor: '#9FB17C', padding: '8px', color: 'white', fontWeight: 'bold' }}>{(100 * qualifications.tauxClientNbReclamations/qualifications.tauxClientNbBLExpedies).toFixed(2)}%</span></p>
                        <p>Sur les 6 derniers mois, au client, Nb d'expédition : {qualifications.tauxClientNbBLExpedies} - Nb dossier après-vente : {qualifications.tauxClientNbReclamations}</p>

                    </Paper>    
                )}

                {qualifications.details !== undefined && qualifications.details.length > 0 && (
                    <Paper className={classes.paper}>
                        <React.Fragment>
                            {qualifications.details.map((detail, index) => {
                                let value = detail.value;
                                let detailTooltip = '';

                                // BOOLEEN
                                if (detail.type === ReclamationQualificationDetailType.Booleen)
                                    value = (detail.value ? 'Oui' : 'Non');

                                // DATE
                                if (detail.type === ReclamationQualificationDetailType.Date)
                                    value = (<Datetime datetime={detail.value} />);

                                // CHOIX SIMPLE
                                if (detail.type === ReclamationQualificationDetailType.ChoixSimple) {
                                    value = value.libelle;
                                    detailTooltip = "Choix : " + detail.value.choix;
                                }


                                // TransporteurId
                                if (detail.type === ReclamationQualificationDetailType.TransporteurId)
                                    value = detail.value.nom;

                                // UtilisateurId
                                if (detail.type === ReclamationQualificationDetailType.UtilisateurId) {
                                    //value = detail.value.nom;
                                    value = (<Utilisateur utilisateur={detail.value} format={"simple"}/>);
                                }

                                // Fichier
                                if (detail.type === ReclamationQualificationDetailType.Fichier) {
                                    value = (<Fichier fichierId={detail.value}/>);
                                }

                                return (
                                    <div className={classes.containerLeft} key={index}>

                                        {this.isDevelopment && (
                                            <>
                                                <Tooltip title={`${detail.position} - ${detail.code}`}>
                                                    <Typography className={classes.qualificationDetailLibelle} gutterBottom>- {detail.libelle}</Typography>
                                                </Tooltip>


                                                {detailTooltip && (

                                                    <Tooltip title={`${detailTooltip}`}>
                                                        <span>
                                                            <Typography className={classes.detailValue} variant="body2">{value}</Typography>
                                                        </span>
                                                    </Tooltip>
                                                 )}

                                                {!detailTooltip && (
                                                    <Typography className={classes.detailValue} variant="body2">{value}</Typography>
                                                 )}

                                            </>
                                        )}

                                        {!this.isDevelopment && (
                                            <>
                                                <Typography className={classes.qualificationDetailLibelle} gutterBottom>- {detail.libelle}</Typography>
                                                <Typography className={classes.detailValue} variant="body2">{value}</Typography>
                                            </>
                                        )}

                                    </div>
                                );
                            })}
                        </React.Fragment>
                    </Paper>
                )}

                {qualifications.reclamationParente && (
                    <Paper className={classes.paper}>
                        <div className={classes.container}>
                            <a target="_blank" href={`/reclamations/${qualifications.reclamationParente.id}`} rel="noopener noreferrer" className={classes.link}>
                                <ReclamationPageHeader reclamation={qualifications.reclamationParente} onClickSetVerificationDate={null} afficheVerification={false} parent={true} />
                            </a>
                        </div>
                    </Paper>
                )}

            </React.Fragment>
        );
    }
}

Qualification.propTypes = {
    classes: PropTypes.object.isRequired,
    qualifications: PropTypes.object,
    addNotification: PropTypes.func.isRequired
};

export default withStyles(styles)(Qualification);
